import { Dialog as MuiDialog, DialogProps as MuiDialogProps } from '@mui/material';
import { Theme, css } from '@emotion/react';

const dialogPaper = ({ boxShadows }: Theme) => css`
  box-shadow: ${boxShadows.three};
`;

export type DialogProps = MuiDialogProps;

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
export const Dialog = (props: DialogProps) => {
  return <MuiDialog css={dialogPaper} {...props} />;
};

export default Dialog;
